import { actionCreator, ActionReturnType } from "@itk/typescript-utils";

export enum Action {
  SetIsProductInformationDialogOpen = "@@ITK:SRC:PAGES:CONFIGURATOR:COMPONENTS:PRODUCT-INFORMATION-DIALOG:PRODUCT-INFORMATION-DIALOG-STORE.TS:ACTION:SETISPRODUCTINFORMATIONDIALOGOPEN"
}

type TProductInformationDialogState = {
  isProductInformationDialogOpen?: { productId: string };
};

const initialState: TProductInformationDialogState = {
  isProductInformationDialogOpen: undefined
};

export const productInformationActions = {
  setIsProductInformationDialogOpen: (data: TProductInformationDialogState["isProductInformationDialogOpen"]) => actionCreator(Action.SetIsProductInformationDialogOpen, { data })
};

export const productInformationDialogReducer = (state = initialState, action: ActionReturnType<typeof productInformationActions>): TProductInformationDialogState => {
  switch (action.type) {
    case Action.SetIsProductInformationDialogOpen:
      return { ...state, isProductInformationDialogOpen: action.payload.data };

    default:
      return state;
  }
};
